export const tamilNaduSubdistricts = {
  Ariyalur: [ "Andimadam", "Ariyalur", "Sendurai", "Udayarpalayam" ],
  Chengalpattu: [
    "Chengalpattu", "Cheyyur", "Madurantakam",
    "Pallavaram", "Tambaram", "Thiruporur",
    "Thirukalukundram", "Vandalur"
  ], // :contentReference[oaicite:1]{index=1}
  Chennai: [
    "Ambattur", "Aminjikarai", "Ayanavaram", "Egmore",
    "Guindy", "Madhavaram", "Maduravoyal", "Mambalam",
    "Mylapore", "Perambur", "Purasavakkam",
    "Sholinganallur", "Thiruvottiyur"
  ], // :contentReference[oaicite:2]{index=2}
  Coimbatore: [
    "Annur", "Coimbatore North", "Coimbatore South",
    "Kinathukadavu", "Madukkarai", "Mettupalayam",
    "Palladam", "Pollachi", "Sulur", "Valparai"
  ],
  Cuddalore: [
    "Chidambaram", "Cuddalore", "Kattumannarkoil",
    "Panruti", "Tittakudi", "Vriddhachalam"
  ],
  Dharmapuri: [
    "Dharmapuri", "Harur", "Karimangalam",
    "Nallampalli", "Palacode", "Pappireddipatti",
    "Pennagaram"
  ],
  Dindigul: [
    "Athoor", "Dindigul East", "Dindigul West",
    "Gujiliamparai", "Kodaikanal", "Natham",
    "Nilakottai", "Oddanchattiram", "Palani",
    "Vedasandur"
  ],
  Erode: [
    "Anthiyur", "Bhavani", "Erode", "Gobichettipalayam",
    "Kodumudi", "Modakurichi", "Nambiyur",
    "Perundurai", "Sathyamangalam", "Thalavadi"
  ],
  Kallakurichi: [
    "Chinnasalem", "Kalvarayanmalai", "Kallakurichi",
    "Sankarapuram", "Thirukovilur", "Ulundurpet"
  ],
  Kanchipuram: [
    "Chengalpattu", "Kanchipuram", "Sriperumbudur",
    "Tambaram", "Uthiramerur", "Walajabad",
    "Kundrathur"
  ],
  Kanyakumari: [
    "Agastheeswaram", "Kalkulam", "Killiyoor",
    "Thovalai", "Vilavancode"
  ],
  Karur: [
    "Aravakurichi", "Karur", "Kulithalai",
    "Krishnarayapuram", "Manmangalam", "Pugalur"
  ],
  Krishnagiri: [
    "Anchetty", "Bargur", "Denkanikottai", "Hosur",
    "Krishnagiri", "Pochampalli", "Shoolagiri",
    "Uthangarai"
  ],
  Madurai: [
    "Kallikudi", "Madurai East", "Madurai North",
    "Madurai South", "Madurai West", "Melur",
    "Peraiyur", "Sholavandan", "Thirumangalam",
    "Thiruparankundram", "Usilampatti", "Vadipatti"
  ],
  Mayiladuthurai: [
    "Kuthalam", "Mayiladuthurai", "Poompuhar",
    "Sirkazhi", "Tharangambadi"
  ],
  Nagapattinam: [
    "Kilvelur", "Nagapattinam", "Thirukkuvalai",
    "Vedaranyam"
  ],
  Namakkal: [
    "Kollimalai", "Kumarapalayam", "Mohanur",
    "Namakkal", "Paramathi-Velur", "Rasipuram",
    "Senthamangalam", "Thiruchengode"
  ],
  Nilgiris: [ "Coonoor", "Kotagiri", "Ooty (Udhagamandalam)" ],
  Perambalur: [ "Kunnam", "Perambalur", "Veppanthattai" ],
  Pudukkottai: [
    "Kulathur", "Ponnamaravathi", "Pudukkottai",
    "Thirumayam", "Viralimalai"
  ],
  Ramanathapuram: [
    "Kadaladi", "Kamuthi", "Kilakarai", "Mudukulathur",
    "Paramakudi", "Ramanathapuram", "Rameswaram",
    "Tiruvadanai"
  ],
  Ranipet: [
    "Arcot", "Arakkonam", "Kalavai", "Nemili",
    "Sholinghur", "Walajapet"
  ],
  Salem: [
    "Attur", "Edappadi", "Gangavalli", "Idappadi",
    "Mettur", "Omalur", "Salem North", "Salem South",
    "Salem West", "Sankagiri", "Thalaivasal",
    "Vazhapadi", "Yercaud"
  ],
  Sivaganga: [
    "Devakottai", "Ilayangudi", "Kalayarkoil",
    "Karaikudi", "Manamadurai", "Singampunari",
    "Sivaganga", "Tirupathur", "Tiruppuvanam"
  ],
  Tenkasi: [
    "Alangulam", "Kadayanallur", "Sankarankovil",
    "Sengottai", "Sivagiri", "Tenkasi",
    "Thiruvenkatam", "Veerakeralampudur"
  ],
  Thanjavur: [
    "Kumbakonam", "Orathanadu", "Papanasam",
    "Pattukkottai", "Peravurani", "Thanjavur",
    "Thiruvaiyaru"
  ],
  Theni: [ "Andipatti", "Bodinayakkanur", "Cumbum", "Periyakulam", "Theni" ],
  Thiruvallur: [
    "Avadi", "Gummidipoondi", "Pallipattu",
    "Ponneri", "Tiruvallur", "Uthukkottai"
  ],
  Thiruvarur: [
    "Koothanallur", "Needamangalam", "Nannilam",
    "Thiruvarur", "Valangaiman"
  ],
  Thoothukudi: [
    "Ettayapuram", "Kayathar", "Ottapidaram",
    "Srivaikuntam", "Thoothukudi"
  ],
  Tiruchirappalli: [
    "Lalgudi", "Manachanallur", "Musiri",
    "Srirangam", "Thiruverumbur", "Thottiyam",
    "Tiruchirappalli East", "Tiruchirappalli West"
  ],
  Tirunelveli: [
    "Ambasamudram", "Cheranmahadevi", "Ilankai",
    "Nanguneri", "Palayamkottai", "Radhapuram",
    "Tirunelveli"
  ],
  Tirupathur: [ "Ambur", "Natrampalli", "Tirupathur", "Vaniyambadi" ],
  Tiruppur: [
    "Avinashi", "Dharapuram", "Kangeyam", "Palladam",
    "Tiruppur North", "Tiruppur South", "Udumalpet"
  ],
  Tiruvannamalai: [
    "Arni", "Chengam", "Cheyyar", "Polur",
    "Thandrampet", "Tiruvannamalai", "Vandavasi"
  ],
  Vellore: [ "Gudiyattam", "Katpadi", "Vellore", "Walajah" ],
  Viluppuram: [
    "Gingee", "Marakanam", "Tindivanam", "Vanur",
    "Villupuram"
  ],
  Virudhunagar: [
    "Aruppukkottai", "Kariapatti", "Rajapalayam",
    "Sattur", "Srivilliputhur", "Sivakasi",
    "Virudhunagar"
  ]
};
